var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgQuoting(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 18.75,
    height: 15,
    viewBox: "0 0 18.75 15",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M8.979-4.512,3,1.465a1.356,1.356,0,0,1-1,.41,1.356,1.356,0,0,1-1-.41L7.983-5.508.337-13.125H1.772a1.356,1.356,0,0,1,1,.41L8.979-6.5a1.356,1.356,0,0,1,.41,1A1.356,1.356,0,0,1,8.979-4.512Zm-3.75,0L-.747,1.465a1.356,1.356,0,0,1-1,.41,1.356,1.356,0,0,1-1-.41L-8.95-4.746a1.356,1.356,0,0,1-.41-1v-5.977a1.356,1.356,0,0,1,.41-1,1.356,1.356,0,0,1,1-.41h5.977a1.356,1.356,0,0,1,1,.41L5.229-6.5a1.356,1.356,0,0,1,.41,1A1.356,1.356,0,0,1,5.229-4.512Zm-1-1-6.211-6.211H-7.954v5.977L-1.743.469ZM-6.138-9.9a1.356,1.356,0,0,1,1-.41,1.356,1.356,0,0,1,1,.41,1.356,1.356,0,0,1,.41,1,1.356,1.356,0,0,1-.41,1,1.356,1.356,0,0,1-1,.41,1.356,1.356,0,0,1-1-.41,1.356,1.356,0,0,1-.41-1A1.356,1.356,0,0,1-6.138-9.9Z",
    transform: "translate(9.36 13.125)",
    fill: "#7f7f7f"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgQuoting);
export default __webpack_public_path__ + "static/media/quoting.1fd82392b65aeb2911c1394132e2df11.svg";
export { ForwardRef as ReactComponent };